import React, { Component } from "react";
import Modal from "../Modal/Modal";
import classes from "../Confirm/Confirm.css";
import { AiFillWarning } from "react-icons/ai";

class AuthError extends Component {
    constructor() {
        super();
        this.state = {
            show: false,
        };
        window.sessionTimeoutModal = this;
    }

    render() {
        return (
            <Modal
                show={this.state.show}
                showCloseIcon
                modalClosed={() => this.setState({ show: false })}
            >
                <div style={{ padding: "0.5rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                        <AiFillWarning color="#F93875" size={40} />
                        <h2>Session Timeout</h2>
                    </div>
                    <p style={{ marginBottom: "2rem" }}>
                        Session has timed out. Please start a new session and try again. If error persists, please contact your supervisor.
                    </p>
                    <button
                        className={classes.ConfirmButton}
                        onClick={() => {
                            const esso = sessionStorage.getItem('esso');
                            let accountNumber = sessionStorage.getItem('accountNumber')
                            if(!accountNumber || accountNumber==='undefined'){ 
                                accountNumber = sessionStorage.getItem('masterAcct')
                            }
                            sessionStorage.clear()
                            localStorage.clear()
                            location.assign(`${esso}${accountNumber}`);
                        }}
                    >
                        Refresh
                    </button>
                </div>
            </Modal >
        );
    }
}

export default AuthError;

export class AuthErrorApi {
    constructor() { }

    static show = () => {
        window.sessionTimeoutModal.setState({ show: true });
    }; 

    static hide = () => {
        window.sessionTimeoutModal.setState({ show: false });
    };
}
